import React, { FC, ReactNode } from "react";
import { useFetch } from "../../core/components/crud/contexts/fetch.context";
import Spinner from "../layout/Spinner";

export const SpinWhileFetching: FC<{ children?: ReactNode }> = ({ children }) => {
    const { fetching } = useFetch();
    return <>{fetching ? <Spinner /> : children}</>;
};
